import styled from "styled-components"
import Breakpoints from "../shared/breakpoints"
import Typography from "../shared/typography.styles"

export const CopyText = styled.p`
  ${Typography.mobileTextStyles.MobileBodyRegular}
  font-size: 16px;
  text-align: center;
  margin: 24px 20px 0 20px;
  @media (min-width: ${Breakpoints.md}) {
    max-width: 75vw;
    margin: 24px auto 0 auto;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${Typography.desktopTextStyles.BodyText18}
    max-width: 670px;
    width: 46.5vw;
  }
`
